import { createMigration } from './utils';

export const migrationTo9_201 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            const path = ['mediaAsset'];
            migrateAsset(map, path);
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            // migrate scene children
            map.get('children', []).forEach((_, c) => {
                const path = ['children', c];
                migrateAsset(map, path);
            });

            // migrate scene subslides
            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((child, c) => {
                    if (child.get('classType') !== 'TimeAwareMediaAsset') {
                        return;
                    }
                    const path = ['subslides', s, 'children', c];
                    migrateAsset(map, path);
                });
            });
        });
    },
});

function migrateAsset(map, path) {
    const asset = map.getIn(path);
    if (!asset) {
        return;
    }
    if (asset.get('classType') !== 'TimeAwareMediaAsset') {
        return;
    }
    const filters = asset.get('filters');
    if (!filters) {
        return;
    }
    filters.forEach((filter, i) => {
        if (filter.get('name') === 'BrightnessFilter_1') {
            map.setIn([...path, 'filters', i, 'classType'], 'AdjustmentFilter');
            map.setIn([...path, 'filters', i, 'name'], 'AdjustmentFilter_1');
        }
    });
}
